import type { AgentSimpleResponseDTO } from "web_myplann/Infrastructure/Api/Api";

type TaskPeople = {
	author: AgentSimpleResponseDTO;
	assignedTo?: AgentSimpleResponseDTO | null;
};

export const getTaskContact = ({
	author,
	assignedTo,
}: TaskPeople): AgentSimpleResponseDTO => assignedTo ?? author;
